import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';
import { MyMusicSorts } from '../../constants/Collection';
import { FilterNavTypes } from '../../constants/FilterTypeNav';
import { MyStationDisplayTypes, MyStationSortTypes } from '../../constants/MyStations';
import QA from '../../constants/QATags';

export const MyMusicSortDropdownKey = Symbol('MyMusicSortDropdown');
const podcastFilterNavTypes = [FilterNavTypes.PODCASTS, FilterNavTypes.EPISODES];
class MyMusicSortDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.shape({
      onSortClicked: PropTypes.func.isRequired,
      activeSort: PropTypes.string,
      sortOptions: PropTypes.object.isRequired,
      sortMessages: PropTypes.object.isRequired,
      filter: PropTypes.string,
    }),
    closeDropdown: PropTypes.func,
    dropdownType: PropTypes.any,
  };

  getSortLabel = sortType => {
    if (
      sortType === MyMusicSorts.RECENT &&
      this.props.childProps.filter !== FilterNavTypes.PLAYLISTS
    ) {
      return MyStationSortTypes.RECENTLY_COLLECTED;
    }
    return sortType;
  };

  getSortOption = sortType => {
    if (
      sortType === MyStationSortTypes.RECENT &&
      !podcastFilterNavTypes.includes(this.props.childProps.filter)
    ) {
      return MyStationDisplayTypes.RECENT;
    }
    return sortType;
  };

  getQaTag = sortOption => {
    if (sortOption === MyMusicSorts.A_TO_Z) {
      return QA.MCALPHAO;
    } else if (sortOption === MyMusicSorts.RECENT) {
      return QA.MCRAO;
    }
    return '';
  };

  render() {
    return (
      <DropdownBox menuType={this.props.dropdownType}>
        {values(this.props.childProps.sortOptions).map((sortType, i) => {
          const sortLabel = this.getSortLabel(sortType);
          const sortOption = this.getSortOption(sortType);
          const qaTag = this.getQaTag(sortOption);
          const optionProps = {
            label: <FormattedMessage {...this.props.childProps.sortMessages[sortLabel]} />,
            isSelected: sortOption === this.props.childProps.activeSort,
            isSelectable: true,
            key: `mymusicSortOption_${sortOption}`,
            extrasStyles: ['DropdownOption--black'],
            callback: () => {
              this.props.childProps.onSortClicked(sortOption);
              this.props.closeDropdown();
            },
            qaTag,
          };

          return <Option key={i} {...optionProps} />;
        })}
      </DropdownBox>
    );
  }
}

export const constructors = {
  [MyMusicSortDropdownKey]: MyMusicSortDropdown,
};
